/**
 * @fileoverview Environment-aware browser telemetry sampling.
 * @module web-telemetry/sampling
 *
 * Responsibilities:
 * - Resolve the Application Insights `samplingPercentage` for the browser SDK by env.
 * Dependencies:
 * - none (pure function).
 * Architecture:
 * - Mirrors the backend `resolveSamplingPercentage` in @firesquirrel/logging so browser
 *   and server sampling stay aligned (prod 100 / stage 50 / dev 10).
 * Notes:
 * - prod = 100% (full fidelity), stage = 50%, dev/unknown = 10% (keep cost low).
 */

export type TelemetryAppEnv = 'dev' | 'stage' | 'prod' | string;

/**
 * @process resolveBrowserSamplingPercentage
 * Steps:   map appEnv → percentage; unknown envs fall back to the dev rate.
 * Inputs:  appEnv ('prod' | 'stage' | 'dev' | other).
 * Outputs: integer percentage in [1,100].
 * Failure Handling: none — total function.
 * Idempotency: REQUIRED (pure).
 */
export function resolveBrowserSamplingPercentage(appEnv: TelemetryAppEnv): number {
  if (appEnv === 'prod') return 100;
  if (appEnv === 'stage') return 50;
  return 10;
}
